export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANYUPDATE_SUCCESS";
export const ADD_COMPANY_SUCCESS = "ADD_COMPANY_SUCCESS";
export const ACTIVATE_COMPANY_SUCCESS = "ACTIVATE_COMPANY_SUCCESSs";
export const IN_ACTIVATE_COMPANY_SUCCESS = "IN_ACTIVATE_COMPANY_SUCCESS";
